const MAX_DECIMAL_PLACES = 3;

export const formatMeasurement = (value) => {
  if (value === null || value === undefined || value === '') return '-';
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return '-';
  const rounded = Math.round((numeric + Number.EPSILON) * (10 ** MAX_DECIMAL_PLACES))
    / (10 ** MAX_DECIMAL_PLACES);
  return Object.is(rounded, -0) ? '0' : String(rounded);
};

export const formatMaterialSize = (shapeCode, shapeLabel, size1, size2) => {
  const hasShapeCode = shapeCode !== null && shapeCode !== undefined && shapeCode !== '';
  const isRound = hasShapeCode ? Number(shapeCode) === 1 : shapeLabel === '원형';
  if (isRound) {
    const primary = Number(size1);
    const useLegacySecondary = size1 !== null && size1 !== undefined && size1 !== ''
      && Number.isFinite(primary) && primary === 0
      && Number.isFinite(Number(size2)) && Number(size2) > 0;
    return `Ø${formatMeasurement(useLegacySecondary ? size2 : size1)}`;
  }
  return `${formatMeasurement(size1)} x ${formatMeasurement(size2)}`;
};
